@if (successSSOLogin) {
<app-header2 [path]="currentPath" [appName]="title3"> </app-header2>
}
<div class="main-container mainContainer-Padding">
  @if (appLoader) {
  <app-loader></app-loader>
  } @if (successSSOLogin) {
  <router-outlet name="sidebar"></router-outlet>
  <div
    [ngClass]="{
      'add-page-background': isPathApplicationInsights,
      'add-no-background': !isPathApplicationInsights,
      'container-no-padding': currentUrl === '/landing-page'
    }"
    class="container container-backgroundcolor"
  >
    <router-outlet></router-outlet>
  </div>
  }
</div>
@if (successSSOLogin) {
<app-footer2 [path]="currentPath"></app-footer2>
}
<span id="base-timer-label" class="base-timer__label"> </span>
<div class="modal-container">
  <div id="SessionModal" class="SessionModal modal">
    <div class="modal-content">
      <div>
        <h6 style="padding:5px;">
          Your session <span id="countdown"> </span>, Please click on Continue to stay Signed In.
        </h6>
      </div>
      <div style="display: flex;justify-content: space-evenly;">
        <button
          mat-mdc-raised-button
          class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
          (click)="continue()"
          style="margin-top: 10px;"
        >
          Continue
        </button>
      </div>
    </div>
  </div>
  <div id="DataChangeModal" class="DataChangeModal modal">
    <div class="modal-content">
      <div>
        <h6 style="padding:5px;">
          The information you're looking at is outdated. Please click Refresh to reload the page.
        </h6>
      </div>
      <div style="display: flex;justify-content: space-evenly;">
        <button
          mat-mdc-raised-button
          class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button uitk-u-margin-right--base uitk-u-margin-bottom--xs"
          (click)="refesh()"
          style="margin-top: 10px;"
        >
          Refresh
        </button>
      </div>
    </div>
  </div>
</div>
